const state = {
    programs: [
        {
            _id: 0,
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GSoC-icon.svg/1200px-GSoC-icon.svg.png',
            title: 'Google Summer of Code',
            start_date: 'January',
            end_date: 'August',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'The Google Summer of Code, often abbreviated to GSoC, is an international annual program in which Google awards stipends to students who successfully complete a free and open-source software coding project during the summer. The program is open to university students aged 18 or over.',
            timeline: 'https://summerofcode.withgoogle.com/how-it-works/#timeline',
            link: 'https://developers.google.com/open-source/gsoc/',
            color: '#CAF4F4',
        },
        {
            _id: 1,
            image: 'https://fellowship.mlh.io/_next/image?url=%2Fimg%2Flogo-light.svg&w=256&q=75',
            title: 'MLH Open Source Fellowship',
            start_date: 'June, September',
            end_date: 'August, December',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: false },
            description: 'The MLH Fellowship is a 12 week internship alternative for aspiring software engineers. Instead of interning at a single company, on the Open Source Track you\'ll contribute to the type of Open Source projects that every company depends on.',
            timeline: 'https://fellowship.mlh.io/programs/open-source',
            link: 'https://fellowship.mlh.io/programs/open-source',
            color: '#f6aad0',
        },
        {
            _id: 2,
            image: 'https://developers.google.com/season-of-docs/images/logo/SeasonofDocs_Icon_Grey_300ppi-whitespace-cropped.png',
            title: 'Season of Docs',
            start_date: 'February',
            end_date: 'November',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: false },
            description: 'Season of Docs provides support for open source projects to improve their documentation and gives professional technical writers an opportunity to gain experience in open source. Together we raise awareness of open source, of docs, and of technical writing.',
            timeline: 'https://developers.google.com/season-of-docs/docs/timeline',
            link: 'https://developers.google.com/season-of-docs/',
            color: '#CAEFD1',
        },
        {
            _id: 3,
            image: 'https://kde.org/stuff/clipart/logo/kde-logo-bluegradient-w-slug-vectorized.svg',
            title: 'Season of KDE',
            start_date: 'December',
            end_date: 'May',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: false },
            description: 'KDE Student Programs has been running Season of KDE as a program similar to, but not quite the same as Google Summer of Code, offering an opportunity to everyone (not just students) to participate in both code and non-code projects that benefits the KDE ecosystem',
            timeline: 'https://season.kde.org/',
            link: 'https://season.kde.org/',
            color: '#DCE5FD',
        },
        {
            _id: 4,
            image: 'https://cdn-media-1.freecodecamp.org/images/b-dH-s55d1HXEBiv3uiVe3RocpZ6LQylbhRV',
            title: 'Outreachy',
            start_date: '"February,	September"',
            end_date: 'August, March',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'Outreachy is a diversity initiative that provides paid, remote internships to people subject to systemic bias and impacted by underrepresentation in the technical industry where they are living.',
            timeline: 'https://www.outreachy.org/',
            link: 'https://www.outreachy.org/',
            color: '#aad0f6',
        },
        {
            _id: 5,
            image: 'https://railsgirlssummerofcode.org/img/sprites/logo_subnavi.png',
            title: 'RGSOC',
            start_date: 'July',
            end_date: 'September',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'Rails Girls Summer of Code is a global fellowship program for women and non-binary coders. Students receive a three-month scholarship to work on existing Open Source projects and expand their skill set.',
            timeline: 'https://railsgirlssummerofcode.org/',
            link: 'https://railsgirlssummerofcode.org/',
            color: '#FFA07A',
        },
        {
            _id: 6,
            image: 'https://wiki.lfnetworking.org/s/-xuk22b/8401/c06149f9b8308a0beb580e4deed399f7fb2d372d/8.3.5/_/download/resources/com.atlassian.auiplugin:split_aui.splitchunk.vendors--f5244b0828/assets/confluence-white.svg',
            title: 'LFN Mentorship Program',
            start_date: 'January',
            end_date: 'June',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: false },
            description: 'The LF Networking (LFN) intern/mentorship program is aimed at creating a structured hands-on learning opportunity for new developers who may otherwise lack the opportunity to gain exposure to open source software development and entry to the LFN projects\' technical communities',
            timeline: 'https://wiki.lfnetworking.org/display/LN/LFN+Mentorship+Program#LFNMentorshipProgram-2020ProgramTimeline*',
            link: 'https://wiki.lfnetworking.org/display/LN/LFN+Mentorship+Program',
            color: '#B3EE3A',
        },
        {
            _id: 7,
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/X.Org_Logo.svg/250px-X.Org_Logo.svg.png',
            title: 'The X.Org - EVoC',
            start_date: 'January ',
            end_date: 'August',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'The X.Org project provides an open source implementation of the X Window System. The development work is being done in conjunction with the freedesktop.org community. The X.Org Foundation is the educational non-profit corporation whose Board serves this effort, and whose Members lead this work.',
            timeline: 'https://summerofcode.withgoogle.com/how-it-works/#timeline',
            link: 'https://www.x.org/wiki/',
            color: '#FFF2CC',
        },
        {
            _id: 8,
            image: 'https://julialang.org/assets/infra/logo.svg',
            title: 'Julia Summer of Code',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'The Julia Seasons of Contributions (JSoC) are the seasonal programs for funding and/or mentoring students and other developers to contribute to the open source ecosystem. Below are the current programs that the Julia Language is participating in.',
            timeline: 'https://julialang.org/jsoc/',
            link: 'https://julialang.org/jsoc/',
            color: '#FFFF7E',
        },
        {
            _id: 9,
            image: 'http://static.fsf.org/nosvn/stickers/fsf.svg',
            title: 'Free Software Foundation Internship',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'This is an educational opportunity to work with the organization that sponsors the GNU Project, publishes the GNU General Public License (GPL), and fights for software freedom.',
            timeline: 'https://www.fsf.org/volunteer/internships',
            link: 'https://www.fsf.org/volunteer/internships',
            color: '#CAF4F4',
        },
        {
            _id: 10,
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Radare2.svg/398px-Radare2.svg.png',
            title: 'Radare Summer of Code',
            start_date: 'March',
            end_date: 'September',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'The radare project started in February 2006 aiming to provide a free and simple command line interface for an hexadecimal editor supporting 64 bit offsets to search within and recover data from hard-disks.',
            timeline: 'https://rada.re/gsoc/2020/',
            link: 'https://rada.re/gsoc/2020/',
            color: '#aad0f6',
        },
        {
            _id: 11,
            image: 'https://summer.haskell.org/images/haskell-logo.png',
            title: 'Summer of Haskell',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: false, surprise_gifts: false },
            description: 'The Summer of Haskell is an effort by Haskell.Org to reach out to students and encourage them to contribute to the Haskell community with the aid of experienced mentors. This program is open to college students, 18 or older, in most countries.',
            timeline: 'https://developers.google.com/open-source/gsoc/timeline',
            link: 'https://summer.haskell.org/',
            color: '#aad0f6',
        },
        {
            _id: 12,
            image: 'https://avatars.githubusercontent.com/u/16903873?s=200&v=4',
            title: 'Open Mainframe Project',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: ' The Open Mainframe Project (OMP), an open source initiative that enables collaboration across the mainframe community to develop shared tool sets and resources',
            timeline: 'https://www.openmainframeproject.org/',
            link: 'https://www.openmainframeproject.org/',
            color: '#DCE5FD',
        },
        {
            _id: 13,
            image: 'https://processingfoundation.org/content/1-home/processing-social.jpg',
            title: 'Processing Foundation Fellowship',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'The Processing Foundation Fellowship program sponsors artists, designers, activists, educators, engineers, researchers, coders, and collectives—and many combinations of these—in projects that conceive a new direction for what our software and community can do',
            timeline: 'https://processingfoundation.org/fellowships',
            link: 'https://processingfoundation.org/fellowships',
            color: '#FDE0D9',
        },

        {
            _id: 14,
            image: 'https://rare-technologies.com/wp-content/uploads/2016/02/rare_image_only.png',
            title: 'RARE Technologies Student Incubator Programme',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'Our student Incubator offers a unique mix of academic mentorship, hand-on project work and technical training. It is a highly selective program where you will be mentored by an industry expert as you develop a pragmatic solution to a real-world problem using machine learning.',
            timeline: 'https://rare-technologies.com/incubator/#details',
            link: 'https://rare-technologies.com/incubator/',
            color: '#FFFF7E',
        },
        {
            _id: 15,
            image: 'https://fossasia.org/img/fossasia-squarewhite-path.png',
            title: 'FOSSASIA Internship Programme',
            start_date: 'Whole Year',
            end_date: '',
            perks: { swags: true, stipend: true, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'We create Open Source software and open hardware from science apps like the Pocket Science Lab (PSLab), event management systems (Eventyay), big "open" data analytics software (loklak), Open Source personal assistants (SUSI.AI), tools for development (Scrum Helper), to Android apps like the imaging app Phimp.me.',
            timeline: 'https://docs.google.com/forms/d/e/1FAIpQLScp8h5SIPVK5G2SAm5vtrv7KLKeOeYTxlZBkDRE6I7Toybt0A/viewform',
            link: 'https://fossasia.org/',
            color: '#aad0f6',
        },
        {
            _id: 16,
            image: 'https://www.hyperledger.org/wp-content/uploads/2021/01/Hyperledger_Logo_NoTag_Color.svg',
            title: 'Hyperledger Mentorship Program',
            start_date: 'Whole Year',
            end_date: '',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: false },
            description: 'Hyperledger is an open source collaborative effort created to advance cross-industry blockchain technologies. It is a global collaboration, hosted by The Linux Foundation, including leaders in finance, banking, IoT, supply chain, manufacturing and technology',
            timeline: 'https://wiki.hyperledger.org/display/INTERN/How+to+Apply',
            link: 'https://www.hyperledger.org/category/hyperledger-summer-mentorship-program',
            color: '#FFA07A',
        },
        {
            _id: 18,
            image: 'https://static1.squarespace.com/static/59a5b8f849fc2bb49c4fa941/t/5d79d9721cb6fa0c9c8e4004/1589582754695/?format=1500w',
            title: 'Millennium Fellowship',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: false, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'The United Nations Academic Impact and MCN proudly present the Millennium Fellowship. The Fellowship is a semester-long leadership development program on your campus to take your social impact to the next level.  Access to world class training, connections, and recognition is just an application away.',
            timeline: 'https://www.millenniumfellows.org/fellowship',
            link: 'https://www.millenniumfellows.org/',
            color: '#CAF4F4',
        },
        {
            _id: 19,
            image: 'https://cdn.shortpixel.ai/spai/q_lossy+ret_img/https://numfocus.org/wp-content/uploads/2016/07/Matplotlib_Logo_191209.png',
            title: 'John Hunter Matplotlib Summer Fellowship',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'The John Hunter Matplotlib Summer Fellowship, named in memory of Matplotlib creator John Hunter, sponsors one to two students to work full-time for 3 months on Matplotlib during the summer (in the northern hemisphere), supervised and mentored by a senior contributor from the project. The fellowship is designed to help prepare recipients to become active contributors and core maintainers of Matplotlib.',
            timeline: 'https://numfocus.org/programs/john-hunter-technology-fellowship',
            link: 'https://numfocus.org/programs/john-hunter-technology-fellowship',
            color: '#CAEFD1',
        },
        {
            _id: 20,
            image: 'https://static.gnome.org/img/gnome-logo.svg',
            title: 'GNOME Internship Program',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'GNOME internships provide a three-month internships for any person eligible by the eligibility rules. Interns are paid a stipend of $8000 per internship.Each project defines its timeline in its description, located in its main wiki page',
            timeline: 'https://wiki.gnome.org/Internships#Timeline',
            link: 'https://wiki.gnome.org/Internships',
            color: '#FDE0D9',
        },
        {
            _id: 21,
            image: 'https://omshinde.github.io/assets/images/earthEngine.jpg',
            title: 'Google Summer of Earth Engine',
            start_date: 'March',
            end_date: 'August',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'Google Summer of Earth Engine is a research program for Indian university students & researchers to get a chance to work with leading research organizations in the country working in environment, conservation, water resources and agricultural domains over 3 months of summer on a project and get paid to do so!',
            timeline: 'https://sites.google.com/view/summerofearthengine/timeline',
            link: 'https://sites.google.com/view/summerofearthengine/home',
            color: '#B3EE3A',
        },
        {
            _id: 22,
            image: 'https://www.programmersought.com/images/526/ed788428d79f3bf09e1c7afa209923ce.png',
            title: 'Alibaba Summer of Code',
            start_date: 'May',
            end_date: 'September',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'Our goal is to work with open-source communities to create a sincere and fair open-source internship platform. We hope to introduce the world to the Chinese open-source community and its developers through Alibaba prowess in open-source technology.',
            timeline: 'https://developer.aliyun.com/',
            link: 'https://www.alibabacloud.com/blog/alibaba-summer-of-code-2020-leading-the-new-open-source-trend_596241',
            color: '#FFF2CC',
        },
        {
            _id: 23,
            image: 'https://linuxfoundation.org/wp-content/uploads/lf_logo.svg',
            title: 'Linux Kernel Mentorship Program',
            start_date: 'Spring, Summer, Fall',
            end_date: '',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'The Linux Foundation Mentorship Program is designed to help developers — many of whom are first-time open source contributors — with necessary skills and resources to learn, experiment, and contribute effectively to open source communities. By participating in a mentorship program, mentees have the opportunity to learn from experienced open source contributors as a segue to get internship and job opportunities upon graduation.',
            timeline: 'https://wiki.linuxfoundation.org/lkmp/lkmp_schedule',
            link: '',
            color: '#DCE5FD',
        },
        {
            _id: 24,
            image: 'https://linuxfoundation.org/wp-content/uploads/lf_logo.svg',
            title: 'Community Bridge Mentorship (by Linux Foundation)',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: ' A platform created to empower open source developers – and the individuals and organizations who support them – to advance sustainability, security, and diversity in open source technology.',
            timeline: 'NA',
            link: 'https://mentorship.lfx.linuxfoundation.org/#projects',
            color: '#FFA07A',
        },
        {
            _id: 25,
            image: 'http://www.pclubsummerofcode.in/static/mentors/img/pclub-logo.png',
            title: 'PClub Summer Of Code',
            start_date: 'June',
            end_date: 'September',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: true },
            description: 'PClub Summer of Code is the 2 month long Open Source program during summers conducted by Programming Club, UIET, with an aim to help beginners get started with Open Source Development while encouraging diversity. Throughout the program, participants contribute to different projects under guidance of experienced mentors. Mentors get to make their ideas alive and Mentees get to learn tech',
            timeline: 'http://www.pclubsummerofcode.in/',
            link: 'http://www.pclubsummerofcode.in/',
            color: '#FFFF7E',
        },
        {
            _id: 26,
            image: 'https://rubyme.org/rubyme.svg',
            title: 'RubyMe Mentorship Program',
            start_date: 'NA',
            end_date: 'NA',
            perks: { swags: true, stipend: true, cash_price: true, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'Build up professional development experience by contributing to open source projects with the help of a mentor. RubyMe pairs early-career developers from under-represented backgrounds with seasoned Rubyists.',
            timeline: 'NA',
            link: 'https://rubyme.org/',
            color: 'aad0f6',
        },
        {
            _id: 27,
            image: 'https://letsgrowmore.in/wp-content/uploads/2021/05/growmore-removebg-preview.png',
            title: 'LetsGrowMore Summer Of Code (LGMSOC)',
            start_date: 'May',
            end_date: 'July',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: true, certificates: true, surprise_gifts: true },
            description: 'LGM – SOC is an online program designed to encourage student participation in open source software development under the guidance of mentors from the open source community. As it’s the present demand and students need, so we come with LGM – SOC.',
            timeline: 'https://letsgrowmore.in/soc/',
            link: 'https://letsgrowmore.in/',
            color: '#DCE5FD',
        },
        {
            _id: 28,
            image: 'https://res.cloudinary.com/practicaldev/image/fetch/s--HEes59x2--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://media-exp1.licdn.com/dms/image/C4E0BAQGwlSC3kYclzg/company-logo_200_200/0/1591870925394%3Fe%3D2159024400%26v%3Dbeta%26t%3D4EqTkG6gcwyazMKuyKotSAtD0r5K-nvnkmEYe19jt5E',
            title: 'StudentCode-in',
            start_date: 'June',
            end_date: 'September',
            perks: { swags: true, stipend: false, cash_price: false, internships_opportunity: false, certificates: true, surprise_gifts: true },
            description: 'STUDENT CODE-IN is founded with a vision to promote all-round information to those keen students who are here in the globe finding a way for their obstacle.',
            timeline: 'https://studentcode-in.github.io/index.html',
            link: 'https://studentcode-in.github.io/index.html',
            color: '#FDE0D9',
        },
        // Template 

        // {
        //     _id: 0,
        //     image: '',
        //     title: '',
        //     start_date: '',
        //     end_date: '',
        //     perks: { swags: false, stipend: false, cash_price: false, internships_opportunity: false, certificates: false, surprise_gifts: false },
        //     description: '',
        //     timeline: '',
        //     link: '',
        //     color: '#DCE5FD',
        // },

        // Color combination
        // 1 CAF4F4
        // 2 FDE0D9
        // 3 CAEFD1
        // 4 DCE5FD
        // 5 aad0f6
        // 6 FFA07A
        // 7 FFF2CC 
        // 8 B3EE3A
        // 9 FFFF7E

    ],
}

const getters = {
    allPrograms(state) {
        return state.programs
    },

}

const actions = {
}

const mutations = {
}

export default {
    state,
    getters,
    mutations,
    actions
}
